/* Ott-common */
import { createBackendService } from '@dtvgo/backend-service/normalize';

/* Utils */
import platform from '../utils/platform';
import {
  BACKEND_SERVICE_HOST,
  APP_VERSION,
  ENVIRONMENT,
  APP_THEME,
} from '../utils/env';
import { getAccessTokenData } from '../utils/accessTokenData';
import { getIsBrazil } from '../utils/configUtils';
import { authInterceptor } from './authService';

const backendService = createBackendService({
  host: BACKEND_SERVICE_HOST,
  getAccessTokenData,
  clientType: platform.clientType,
  language: async () => ((await getIsBrazil()) ? 'pt' : 'es'),
  clientId: platform.appName,
  appVersion: APP_VERSION,
  environment: ENVIRONMENT,
  appName: APP_THEME,
  profileToken: () => JSON.parse(localStorage.getItem('profile'))?.profileToken,
  timeout: 60_000,
  authInterceptor,
});

export default backendService;
